import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { ChartGrain, ChartMetric } from "@/types/chart.types";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

type ChartControlsProps = {
  metric: ChartMetric;
  onMetricChange: (m: ChartMetric) => void;
  grain: ChartGrain;
  onGrainChange: (g: ChartGrain) => void;
};

export function ChartControls({
  metric,
  onMetricChange,
  grain,
  onGrainChange,
}: ChartControlsProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center">
      <div className="grid gap-1">
        <div className="text-xs font-medium text-muted-foreground">
          <Trans>Y axis</Trans>
        </div>
        <Select
          value={metric}
          onValueChange={(v) => onMetricChange(v as ChartMetric)}
        >
          <SelectTrigger className="h-9 w-full sm:w-[220px]">
            <SelectValue placeholder={t`Select metric`} />
          </SelectTrigger>
          <SelectContent align="start">
            <SelectItem value="distance">
              <Trans>Distance</Trans>
            </SelectItem>
            <SelectItem value="moving_time">
              <Trans>Moving time</Trans>
            </SelectItem>
            <SelectItem value="elapsed_time">
              <Trans>Total time</Trans>
            </SelectItem>
            <SelectItem value="total_elevation_gain">
              <Trans>Elevation gain</Trans>
            </SelectItem>
            <SelectItem value="count">
              <Trans>Number of activities</Trans>
            </SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="grid gap-1">
        <div className="text-xs font-medium text-muted-foreground">
          <Trans>X axis</Trans>
        </div>
        <Select
          value={grain}
          onValueChange={(v) => onGrainChange(v as ChartGrain)}
        >
          <SelectTrigger className="h-9 w-full sm:w-[220px]">
            <SelectValue placeholder={t`Select grain`} />
          </SelectTrigger>
          <SelectContent align="start">
            <SelectItem value="days">
              <Trans>Days</Trans>
            </SelectItem>
            <SelectItem value="weeks">
              <Trans>Weeks</Trans>
            </SelectItem>
            <SelectItem value="months">
              <Trans>Months</Trans>
            </SelectItem>
            <SelectItem value="years">
              <Trans>Years</Trans>
            </SelectItem>
            <SelectItem value="total">
              <Trans>Total</Trans>
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
